import React, {useState} from 'react';
import {
    Card,
    CardActions,
    Button,
    Goods,
    CardContent,
    Modal, Popup, Flex, FlexItem, Input, Image, IconButton, CardText,
} from '@chatui/core';
import CardTitleWithStatus from "../commonUtils/cardTitleWithStatus";
import GoodsSelect from "../commonUtils/goodsSelect";


function GoodsRemoval(props) {

    const title = props.title? props.title: "Change Product";
    const defaultText = "Change Product";
    const [open, setOpen] = useState(false);
    const [openPop, setOpenPop] = useState(false);

    const status = props.status? props.status: 0;

    const goodsName = props.goodsName? props.goodsName: "Product Name";
    const goodsPrice = props.goodsPrice? props.goodsPrice: "12";
    const goodsDesc = props.goodsDesc? props.goodsDesc: "Product Description";
    const goodsGIL = props.goodsImages!==undefined? props.goodsImages: ["/images/default.png"];

    const [gn, setGN] = useState(goodsName);
    const [gp, setGP] = useState(goodsPrice);
    const [gd, setGD]= useState(goodsDesc)
    const [gil, setGIL] = useState(goodsGIL);
    const [hasSubmitted, setHasSubmitted] = useState(false);

    const setTargetGoods =(item) => {
        setGN(item.name);
        setGP(item.price);
        setGD(item.desc);
        setGIL([item.img]);
    }


    const onGoodsSelect = (item) => {
        setOpen(false);
        setTargetGoods(item[0]);
    }
    const onAcknowledge = () => {
        if (props.onAcknowledge) {
             const table = [
                {name: "name", type: 'text', value: gn},
                {name: "price", type: 'text', value: gp},
                {name: "image", type: 'image', value: gil},
                {name: "description", type: 'text', value: gd},
            ];
            props.onAcknowledge(title, defaultText, table, props.language).then((result)=>{
                if (result.result==='success') {
                    setHasSubmitted(true);
                }
            });
        }
    }
    const uploadImage = (v, event) => {
        if (!v){return}
        // console.log(v, event);
        const file = event.target.files[0];
        const newGIL = [...gil];
        newGIL.push(URL.createObjectURL(file));
        console.log(newGIL);
        setGIL(newGIL);
    };
    const deleteImage = (index) => {
        const newGIL =  [...gil];
        newGIL.splice(index, 1);
        setGIL(newGIL);
    };
    return (
        <div>
            <Card fluid>
                <CardTitleWithStatus
                    title={title}
                    statusText={props.statusList[props.status]}
                ></CardTitleWithStatus>
                <CardText>
                    {defaultText}
                </CardText>
                <Popup
                    height={80}
                    active={openPop}
                    title={"Review"}
                    onClose={()=>setOpenPop(false)}
                >

                    <GoodsSelect
                        active={open}
                        onClose={()=>setOpen(false)}
                        onAcknowledge={(item)=>onGoodsSelect(item)}
                    ></GoodsSelect>

                    <CardContent>
                        <p>Target Products</p>
                        <Flex center>
                            <FlexItem flex={"3"}>
                                <Goods
                                    type={"products"}
                                    name={gn}
                                    img={gil[0]}
                                    desc={gd}
                                    price={gp}
                                    currency={"S$"}
                                >
                                </Goods>
                            </FlexItem>
                            <FlexItem>
                                <Button onClick={()=>setOpen(true)} size={'md'}>choose</Button>
                            </FlexItem>
                        </Flex>
                        <CardContent>
                            <p>Name</p>
                            <Input value={gn} onChange={(val) => setGN(val)}></Input>
                        </CardContent>
                        <CardContent>
                            <p>Price</p>
                            <Input value={gp} onChange={(val) => setGP(val)}></Input>
                        </CardContent>
                        <CardContent>
                            <p>Image</p>
                            {gil.map((u, index)=>(
                                <Flex key={index} inline direction={"column"} style={{"margin": "5px", "border": "2px"}}>
                                    <Image src={u} width={80} height={80} ></Image>
                                    <IconButton icon={"close"} onClick={()=>{deleteImage(index)}}></IconButton>
                                </Flex>
                            ))}
                            {/*<Button style={{"width": "80px", "height": "80px"}} icon={"plus"}></Button>*/}
                            <Input type="file" accept="image/*" onChange={(v,event)=>uploadImage(v, event)}></Input>
                        </CardContent>
                        <CardContent>
                            <p>Description</p>
                            <Input value={gd} onChange={(val) => setGD(val)} autoSize={true}></Input>
                        </CardContent>

                    </CardContent>

                </Popup>


                <CardActions>

                    <Button disabled={hasSubmitted} onClick={()=>setOpenPop(true)}>{"Revise"}</Button>
                    <Button disabled={hasSubmitted} color="primary" icon={"x-circle-fill"} onClick={onAcknowledge}>{"Submit"}</Button>
                </CardActions>
            </Card>
        </div>
    );
}

export default GoodsRemoval;